import { z } from 'zod';

export const formattingPreferencesSchema = z.object({
  decimal_separator: z.string(),
});

export type FormattingPreferencesType = z.infer<typeof formattingPreferencesSchema>;

const defaultPref = {
  decimal_separator: ',',
};

export const formattingPreferencesDefaultValue = JSON.stringify(defaultPref);

export const getDefaultFormattingPreferences = (): FormattingPreferencesType => {
  return JSON.parse(formattingPreferencesDefaultValue);
};
